import { Component, ViewChild } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";

import { VTabComponent } from "@app/directives/_layout/v-tabs/v-tab.component";
import { VTabsComponent } from "@app/directives/_layout/v-tabs/v-tabs.component";
import { IAccount } from "@app/services/account.service";
import { DeviceHealthVehiclesComponent } from "../device-health-vehicles/device-health-vehicles.component";
import './device-health.component.scss';

@UntilDestroy()
@Component({
    selector: 'device-health',
    template: require('./device-health.component.html')
})
export class DeviceHealthComponent {
    @ViewChild('tabs') tabs: VTabsComponent;
    @ViewChild('vehiclesTab') vehiclesTab: VTabComponent;
    @ViewChild('vehiclesComponent') vehiclesComponent: DeviceHealthVehiclesComponent;

    accountSelected(account: IAccount): void {
        this.tabs.selectTab(this.vehiclesTab);
        this.vehiclesComponent.selectAccount(account);
    }
}